import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { toast } from '@/hooks/use-toast';

interface PrefilledBadgeProps {
  domain: string;
  className?: string;
}

export default function PrefilledBadge({ domain, className = '' }: PrefilledBadgeProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(domain);
      setCopied(true);
      toast({
        title: 'Copied to clipboard',
        description: `${domain} copied to clipboard`,
      });
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast({
        title: 'Copy failed',
        description: 'Could not copy to clipboard',
        variant: 'destructive',
      });
    }
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Badge variant="secondary" className="px-3 py-1.5 text-sm font-medium">
        For: {domain}
      </Badge>
      <Button
        variant="ghost"
        size="sm"
        onClick={handleCopy}
        className="h-8 w-8 p-0"
        aria-label="Copy domain to clipboard"
      >
        {copied ? <Check className="h-4 w-4 text-green-600" /> : <Copy className="h-4 w-4" />}
      </Button>
    </div>
  );
}
